<template>
	<div style="min-width: 500px">
		<div v-if="!isLoading">
			<div class="flex" style="min-height: 150px">
				<div class="gap-2 flex flex-col w-1/2">
					<div>Name: {{ compensation.company.first_name }} {{ compensation.company.last_name }}</div>
					<div>Gesamtbetrag: {{ compensation.meta.amount_cents }} Cent</div>
					<div>Anzahl Fälle: {{ compensation.meta.count }}</div>
				</div>
				<div class="w-1/2 flex">
					<div class="mr-2">
						Dokument:
					</div>
					<div class="h-5 text-sm flex items-center text-connectProBlue cursor-pointer" @click="getDocument()">
						<font-awesome-icon :icon="['fas', 'download']"></font-awesome-icon>
					</div>
				</div>
			</div>
			<div class="flex justify-end">
				<SaveButton @click="save" class="mb-4 btn-blue">{{ $t('close') }}</SaveButton>
			</div>
		</div>
		<LoadingSpinner v-else />
	</div>
</template>
<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Authentication from '@/mixins/Authentication';
import DamageAssessorCaseRepository from '@/api/repositories/DamageAssessorCaseRepository';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';

export default {
	name: 'CompensationUpdateModal',
	components: { BaseButton, SaveButton, LoadingSpinner },
	mixins: [Authentication],
	data() {
		return {
			compensation: {},
			compensationFile: null,
			month: null,
			year: null,
			isLoading: true,
		};
	},
	mounted() {
		this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
		this.isLoading = true;
		const getTotalCompensation = this.$store.getters.getCompensation;
		this.compensation = getTotalCompensation.compensation;
		this.compensationFile = getTotalCompensation.compensationFile;
		this.isLoading = false;
	},
	methods: {
		save() {
			const data = {
				compensation_id: this.compensation.id,
				media: { type: 'document', extension: 'pdf', base64content: this.compensationFile },
				amount_cents: this.compensation.meta.amount_cents,
			};
			new DamageAssessorCaseRepository()
				.updateCompensation(this.compensation.id, data)
				.then(response => {
					this.$root.$emit('updateCase');
					this.$store.commit('setConfirmLeaving', false);
					this.$swal(this.$t('general.success').toString(), this.$t('compensation_saved').toString(), 'success').then(_ => {
						this.$router.go(-1);
					});
				})
				.catch(e => {
					this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
				});
		},
		getDocument() {
			const blob = new Blob([this.base64ToArrayBuffer(this.compensationFile.split(',')[1])], { type: 'application/pdf' });
			const name = 'verguetung.pdf';
			const resolvingUrl = URL.createObjectURL(blob);
			const viewerUrl = `/blobviewer?blobUrl=${encodeURIComponent(resolvingUrl)}&title=${encodeURIComponent(name)}`;
			setTimeout(function() {
				window.open(viewerUrl, '_blank');
				window.URL.revokeObjectURL(viewerUrl);
			}, 200);
		},
		base64ToArrayBuffer(base64) {
			const binaryString = atob(base64);
			const bytes = new Uint8Array(binaryString.length);
			for (let i = 0; i < binaryString.length; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}
			return bytes.buffer;
		},
	},
};
</script>
